module.exports = __webpack_public_path__ + "static/minamo173-b0c17a49f6c06cd685d17e9aabc55e50.png";